import { render, staticRenderFns } from "./InStat.vue?vue&type=template&id=68f9c13e&scoped=true&"
import script from "./InStat.vue?vue&type=script&lang=js&"
export * from "./InStat.vue?vue&type=script&lang=js&"
import style0 from "./InStat.vue?vue&type=style&index=0&id=68f9c13e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f9c13e",
  null
  
)

export default component.exports